import React, { ReactElement } from 'react'
import ProofOfResidencyType from '../../../components/verification-steps/steps/proof-of-residency/ProofOfResidencyType'
import directorVerificationStore from '../../../stores/director-verification.store'

const DirectorProofOfResidencyType: React.FC = (): ReactElement => {
  return <ProofOfResidencyType verificationStore={directorVerificationStore} />
}

export default DirectorProofOfResidencyType
